// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
//
// Number formatting for rui_chart updates, matching the Ruby formats
// (:number, :percent, :currency, :compact). A Ruby lambda cannot run here:
// resolveFormat maps it ("custom") to "number".

export function resolveFormat(raw) {
  return raw && raw !== "custom" ? raw : "number"
}

// 12.0 -> 12, 12.5 -> 12.5; values within 1e-9 of a whole number are whole.
export function plain(n) {
  return Math.abs(n - Math.round(n)) < 1e-9 ? Math.round(n) : Math.round(n * 100) / 100
}

export function compact(v) {
  const a = Math.abs(v)
  const trim = (x) => String(Math.round(x * 10) / 10)
  if (a >= 1e9) return `${trim(v / 1e9)}B`
  if (a >= 1e6) return `${trim(v / 1e6)}M`
  if (a >= 1e3) return `${trim(v / 1e3)}k`
  return String(plain(v))
}

export function formatValue(v, format = "number") {
  const n = Number(v)
  switch (resolveFormat(format)) {
    case "percent": return `${plain(n)}%`
    case "currency": return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    case "compact": return compact(n)
    default: return plain(n).toLocaleString("en-US", { maximumFractionDigits: 2 })
  }
}

// Decimal places present in any of the given numbers (max 2, like formatValue).
export function decimalsOf(...values) {
  return values.reduce((d, v) => {
    const s = String(Number(v))
    const i = s.indexOf(".")
    return Math.max(d, i < 0 ? 0 : Math.min(2, s.length - i - 1))
  }, 0)
}

// Round an in-between tween frame to the precision of its endpoints, so a count
// from 865 to 2315 never shows 2,164.3 on the way.
export function snap(value, decimals) {
  const f = 10 ** decimals
  return Math.round(value * f) / f
}

// Value with its unit, as the server renders it: the unit applies only when no
// value_format was given (the raw format attribute is "custom").
export function valueText(v, rawFormat, unit) {
  const text = formatValue(v, rawFormat)
  return unit && rawFormat === "custom" ? `${text} ${unit}` : text
}

export function shareText(v, base, format = "number") {
  const pct = base === 0 ? 0 : Math.round(Math.abs(v) / base * 100)
  return `${formatValue(v, format)} of ${formatValue(base, format)} · ${pct}%`
}
